export default function StickyButtons() {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      <a
        href="tel:9927256718"
        className="w-14 h-14 flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer"
        aria-label="Call Now"
      >
        <i className="ri-phone-fill text-2xl"></i>
      </a>
      
      <a
        href="https://wa.me/919927256718"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-fill text-2xl"></i>
      </a>
    </div>
  );
}
